import React from 'react'
import { FormWrapper, FormSubmit, FormDisplayErrors } from '@myxplor/forms'
import RemoteRequest from '../../remote-request'
import { apiEndPoint } from '../index'

const DisplayError = () => (
  <FormDisplayErrors
    errors={['Sorry! An error has occurred, please contact your care centre to resolve the issue.']}
  />
)

const FormRender = ({ loading, errors }) => {
  if (Array.isArray(errors) && errors.length > 0) return <DisplayError />

  return (
    <FormSubmit loading={loading} loadingTitle="Approving Enrolment Schedule">
      I Agree
    </FormSubmit>
  )
}

const ApproveButton = ({
  remote_request,
  care_id,
  parent_id,
  record,
  refresh_parent_agreement,
}) => {
  if (typeof remote_request.state.data === 'object' && !!remote_request.state.data.success) {
    refresh_parent_agreement(apiEndPoint({ parent_id, care_id }))
    return null
  }

  return (
    <FormWrapper
      onSubmit={() =>
        remote_request.submit(
          process.env.REACT_APP_API_HOST +
            `/api/parents/${parent_id}/care-enrolments/${care_id}/parent-approvals`,
          {
            method: 'POST',
            jsonAPI: true,
            body: record,
          }
        )
      }
      render={() => (
        <FormRender {...remote_request.state} parent_id={parent_id} care_id={care_id} />
      )}
    />
  )
}

export default RemoteRequest(ApproveButton)



// WEBPACK FOOTER //
// ./src/parent-agreement/views/approve-button.jsx